export const translations = {
  en: {
    translation: {
      common: {
        en: 'English',
        ru: 'Russian',
        error: 'Error',
        yes: 'Yes',
        no: 'No',
        back: 'Back',
      },
      fields: {
        title: 'Title',
        notes: 'Notes',
        done: 'Done',
        folder: 'Folder',
        due_date: 'Due date',
        auto_complete: 'Auto-complete',
        auto_complete_short: 'Auto',
        duration: 'Duration',
        tags: 'Tags',
        energy: 'Energy',
        project: 'Project',
        delegated_to: 'Delegated to',
        reminders: 'Reminders',
        recurring: 'Recurring',
        schedule: 'Schedule',
        condition: 'Condition',
        start_date: 'Start date',
        end_date: 'End date',
      },
      bot: {
        commands: {
          start: 'Start working with assistant',
          help: 'Show commands list',
          clear: 'End current conversation',
          inbox: 'View inbox tasks',
          app: 'Open web application',
        },
        messages: {
          welcome:
            'Hi{{name}}! I am your GTD assistant. I will help you organize tasks using the Getting Things Done methodology.',
          help: `📚 Available commands:

/add <task> - add new task to inbox
/inbox - view inbox tasks
/process - process inbox tasks
/app - open web application`,
          newTask: '📝 New task:\n"{{title}}"',
          time: '⏱️ Time: {{duration}}',
          energy: '⚡ Energy: {{energy}}',
          date: '📅 Date: {{date}}',
          folder: '📁 Folder: {{folder}}',
          selectOptions: '\n\nSelect additional parameters or confirm creation:',
          confirm: '✅ Confirm',
          cancel: '❌ Cancel',
          timeButton: '⏱️ Time{{duration}}',
          energyButton: '⚡ Energy{{energy}}',
          dateButton: '📅 Date{{date}}',
          folderButton: '📁 Folder{{folder}}',
          openApp: '🌐 Open mini-application:',
          launchApp: '🚀 Open GTD App',
          inboxEmpty: 'Inbox is empty! 🎉',
          tasksCount: 'You have {{count}} task{{plural}}',
          provideTask: 'Please provide a task description: /add <task>',
          accessDenied: 'Access denied. User {{userId}} not in allowed users list.',
          missingUserId: 'Message sender ID is missing',
        },
        buttons: {
          appButton: '🚀 GTD App',
          prevPage: '←',
          nextPage: '→',
        },
      },
      progressMessages: {
        add_task: [
          '📝 Jeeves is taking notes in his notepad...',
          '✒️ Jeeves is carefully recording new information...',
          '📔 Jeeves is entering the task in his diary...',
          '✍️ Jeeves is diligently noting your wishes...',
          '📋 Jeeves is methodically filling out documents...',
        ],
        update_task: [
          '✏️ Jeeves is making corrections in his notebook...',
          '📝 Jeeves is correcting existing entries...',
          '✍️ Jeeves is updating information in his registry...',
          '📔 Jeeves is editing task notes...',
          '✒️ Jeeves is carefully correcting assignment details...',
        ],
        delete_task: [
          '🗑️ Jeeves is carefully removing unnecessary records...',
          '✂️ Jeeves is crossing out outdated information...',
          '📤 Jeeves is deleting completed assignment...',
          '🗄️ Jeeves is organizing the filing cabinet...',
          '📝 Jeeves is marking completed tasks...',
        ],
        list_tasks: [
          '📋 Jeeves is reviewing the to-do list...',
          '🔍 Jeeves is studying entries in the diary...',
          '📑 Jeeves is flipping through organizer pages...',
          '📚 Jeeves is checking his records...',
          '📖 Jeeves is reviewing current assignments...',
        ],
        add_memory: [
          '💭 Jeeves is remembering new information...',
          '📝 Jeeves is making an important note in memory...',
          '✍️ Jeeves is recording valuable information...',
          '🧠 Jeeves is adding new knowledge...',
          '📔 Jeeves is writing down important information...',
        ],
        add_project: [
          '📋 Jeeves is creating a new project...',
          '✏️ Jeeves is preparing project documentation...',
          '📁 Jeeves is creating a new folder for the project...',
          '📝 Jeeves is registering a new project...',
          '✨ Jeeves is initializing a new project...',
        ],
        update_project: [
          '📝 Jeeves is updating project information...',
          '✏️ Jeeves is making changes to the project...',
          '📋 Jeeves is correcting project details...',
          '✍️ Jeeves is editing project documentation...',
          '🔄 Jeeves is updating project data...',
        ],
        delete_project: [
          '🗑️ Jeeves is carefully discarding the project...',
          '📤 Jeeves is removing project materials...',
          '✂️ Jeeves is removing the outdated project...',
          '🗄️ Jeeves is cleaning up the project...',
          '📝 Jeeves is closing the project...',
        ],
        list_projects: [
          '📋 Jeeves is reviewing the project list...',
          '🔍 Jeeves is studying current projects...',
          '📑 Jeeves is analyzing project status...',
          '📚 Jeeves is checking project statuses...',
          '📖 Jeeves is compiling a project report...',
        ],
        search: [
          '🔍 Jeeves is searching for your request...',
          '📚 Jeeves is reviewing the database...',
          '🔎 Jeeves is analyzing similar records...',
          '📑 Jeeves is collecting search results...',
          '📖 Jeeves is forming a report on findings...',
        ],
        delete_memory: [
          '🗑️ Jeeves is removing outdated memories...',
          '✂️ Jeeves is clearing unnecessary records from memory...',
          '🧹 Jeeves is organizing memories...',
          '📤 Jeeves is deleting irrelevant information...',
          '🗄️ Jeeves is archiving old notes...',
        ],
        update_memory: [
          '🔄 Jeeves is updating his memories...',
          '✏️ Jeeves is correcting memory records...',
          '📝 Jeeves is clarifying existing information...',
          '✍️ Jeeves is updating information...',
          '📔 Jeeves is refreshing important details...',
        ],
        get_message_history: [
          '🤔 Jeeves is recalling our recent conversation...',
          '💭 Jeeves is restoring our chat from memory...',
          '🧠 Jeeves is collecting his thoughts...',
          '💫 Jeeves is immersing in memories...',
          '🎭 Jeeves is reviving dialogue details in memory...',
        ],
        thinking: [
          '🎩 Jeeves thoughtfully adjusts his tie...',
          '🧐 Jeeves delicately clears his throat, thinking about the answer...',
          '🤔 Jeeves elegantly raises an eyebrow, pondering the question...',
          '✨ Jeeves with impeccable restraint turns to his experience...',
          '👔 Jeeves elegantly straightens his vest, preparing to answer...',
          '📚 Jeeves immerses himself in his encyclopedic knowledge...',
          '⚜️ Jeeves with his characteristic thoroughness considers the situation...',
        ],
        add_alarm: [
          '⏰ Jeeves is setting a new reminder...',
          '🕐 Jeeves is setting an alarm...',
          '📅 Jeeves is marking an important date on the calendar...',
          '⌚ Jeeves is programming a notification...',
          '🔔 Jeeves is setting up an alert...',
        ],
        update_alarm: [
          '⏰ Jeeves is adjusting the reminder time...',
          '🕐 Jeeves is reconfiguring the alarm...',
          '📅 Jeeves is updating the calendar entry...',
          '⌚ Jeeves is changing notification settings...',
          '🔔 Jeeves is editing the alert...',
        ],
        delete_alarm: [
          '⏰ Jeeves is turning off the alarm...',
          '🗑️ Jeeves is removing unnecessary reminder...',
          '✂️ Jeeves is crossing out the reminder from the list...',
          '📤 Jeeves is deleting the set alarm...',
          '🧹 Jeeves is organizing reminders...',
        ],
        list_alarms: [
          '⏰ Jeeves is checking set alarms...',
          '📋 Jeeves is reviewing the reminder list...',
          '🔍 Jeeves is studying scheduled notifications...',
          '📑 Jeeves is checking the reminder schedule...',
          '📚 Jeeves is checking future reminders...',
        ],
        ask_user: [
          '❓ Jeeves respectfully awaits your instructions...',
          '📝 Jeeves has frozen waiting for your instructions...',
          '🎩 Jeeves delicately waits for your decision...',
          '✨ Jeeves attentively listens to your words...',
        ],
      },
      changeSummary: {
        task: {
          created: '- added task [{{title}}](/task/{{id}})',
          updated: '- updated task [{{title}}](/task/{{id}})',
          deleted: '- deleted task "{{title}}"',
          completed: '- completed task [{{title}}](/task/{{id}})',
        },
        project: {
          created: '- added project {{title}}',
          updated: '- updated project {{title}}',
          deleted: '- deleted project {{title}}',
        },
        alarm: {
          created: '- added reminder "{{title}}"',
          updated: '- updated reminder "{{title}}"',
          deleted: '- deleted reminder "{{title}}"',
        },
        memory: {
          created: '- remembered: "{{title}}"',
          updated: '- updated memory: "{{title}}"',
          deleted: '- deleted memory: "{{title}}"',
        },
      },
      jeeves: {
        messages: {
          applyAction: 'Apply this well',
          cancel: 'Cancel',
          error: 'An error occurred!',
          cancelButton: '❌ Cancel',
          ok: '✅ ok',
          userNotFound: 'User not found',
          taskNotFound: 'Task not found',
          suggestAlternative: 'Suggest another option',
          analyzeTaskPrompt: 'Please analyze the task:',
          sessionCleared:
            'Very well, sir. I shall consider our previous conversation concluded. How may I assist you now?',
          sessionClosed: 'I trust the previous matter has been resolved, sir. I am at your disposal for a new inquiry.',
          photoError:
            'I regret to inform you, sir, that I was unable to process the photograph. Perhaps you could try sending it again?',
          errorTemplate: `<b>🎩 I apologize, but I encountered a difficulty processing your message.</b>

To my deepest regret, a technical malfunction occurred. Allow me to provide details:
    
<blockquote expandable>{{error}}</blockquote>
    `,
        },
        buttons: {
          cancel: '❌ Cancel',
          suggestAlternative: '🤔 Suggest another option',
          apply: '✅ Good',
        },
      },
    },
  },
  ru: {
    translation: {
      common: {
        en: 'английский',
        ru: 'русский',
        error: 'Ошибка',
        yes: 'Да',
        no: 'Нет',
        back: 'Назад',
      },
      fields: {
        title: 'Название',
        notes: 'Заметки',
        done: 'Выполнено',
        folder: 'Папка',
        due_date: 'Срок',
        auto_complete: 'Автозавершение',
        auto_complete_short: 'Авто',
        duration: 'Длительность',
        tags: 'Теги',
        energy: 'Энергия',
        project: 'Проект',
        delegated_to: 'Делегировано',
        reminders: 'Напоминания',
        recurring: 'Повторение',
        schedule: 'Расписание',
        condition: 'Условие',
        start_date: 'Дата начала',
        end_date: 'Дата окончания',
      },
      bot: {
        commands: {
          start: 'Начать работу с ассистентом',
          help: 'Показать список команд',
          clear: 'Завершить текущий разговор',
          inbox: 'Просмотр входящих задач',
          app: 'Открыть веб-приложение',
        },
        messages: {
          welcome:
            'Привет{{name}}! Я твой GTD-ассистент. Я помогу тебе организовать задачи по методологии Getting Things Done.',
          help: `📚 Доступные команды:

/add <задача> - добавить новую задачу в inbox
/inbox - просмотр входящих задач
/process - обработка входящих задач
/app - открыть веб-приложение`,
          newTask: '📝 Новая задача:\n"{{title}}"',
          time: '⏱️ Время: {{duration}}',
          energy: '⚡ Энергия: {{energy}}',
          date: '📅 Дата: {{date}}',
          folder: '📁 Папка: {{folder}}',
          selectOptions: '\n\nВыберите дополнительные параметры или подтвердите создание:',
          confirm: '✅ Подтвердить',
          cancel: '❌ Отменить',
          timeButton: '⏱️ Время{{duration}}',
          energyButton: '⚡ Энергия{{energy}}',
          dateButton: '📅 Дата{{date}}',
          folderButton: '📁 Папка{{folder}}',
          openApp: '🌐 Откройте мини-приложение:',
          launchApp: '🚀 Открыть GTD App',
          inboxEmpty: 'Inbox is empty! 🎉',
          tasksCount: 'У вас {{count}} задач{{plural}}',
          provideTask: 'Please provide a task description: /add <task>',
          accessDenied: 'Access denied. User {{userId}} not in allowed users list.',
          missingUserId: 'Message sender ID is missing',
        },
        buttons: {
          appButton: '🚀 GTD App',
          prevPage: '←',
          nextPage: '→',
        },
      },
      progressMessages: {
        add_task: [
          '📝 Дживс делает пометки в своём блокноте...',
          '✒️ Дживс аккуратно записывает новые сведения...',
          '📔 Дживс вносит задачу в свой ежедневник...',
          '✍️ Дживс старательно конспектирует ваши пожелания...',
          '📋 Дживс методично заполняет документы...',
        ],
        update_task: [
          '✏️ Дживс вносит правки в записную книжку...',
          '📝 Дживс корректирует существующие записи...',
          '✍️ Дживс обновляет информацию в своем реестре...',
          '📔 Дживс редактирует заметки о задаче...',
          '✒️ Дживс аккуратно исправляет детали поручения...',
        ],
        delete_task: [
          '🗑️ Дживс аккуратно убирает ненужные записи...',
          '✂️ Дживс вычеркивает устаревшую информацию...',
          '📤 Дживс удаляет завершенное поручение...',
          '🗄️ Дживс наводит порядок в картотеке...',
          '📝 Дживс отмечает выполненные задачи...',
        ],
        list_tasks: [
          '📋 Дживс просматривает список дел...',
          '🔍 Дживс изучает записи в ежедневнике...',
          '📑 Дживс перелистывает страницы органайзера...',
          '📚 Дживс сверяется со своими записями...',
          '📖 Дживс проверяет текущие поручения...',
        ],
        add_memory: [
          '💭 Дживс запоминает новую информацию...',
          '📝 Дживс делает важную пометку в памяти...',
          '✍️ Дживс фиксирует ценные сведения...',
          '🧠 Дживс добавляет новые знания...',
          '📔 Дживс записывает важную информацию...',
        ],
        add_project: [
          '📋 Дживс создает новый проект...',
          '✏️ Дживс оформляет документацию проекта...',
          '📁 Дживс заводит новую папку для проекта...',
          '📝 Дживс регистрирует новый проект...',
          '✨ Дживс инициализирует новый проект...',
        ],
        update_project: [
          '📝 Дживс обновляет информацию о проекте...',
          '✏️ Дживс вносит изменения в проект...',
          '📋 Дживс корректирует детали проекта...',
          '✍️ Дживс редактирует проектную документацию...',
          '🔄 Дживс актуализирует данные проекта...',
        ],
        delete_project: [
          '🗑️ Дживс аккуратно выбрасывает проект...',
          '📤 Дживс удаляет проектные материалы...',
          '✂️ Дживс убирает неактуальный проект...',
          '🗄️ Дживс очищает проект...',
          '📝 Дживс закрывает проект...',
        ],
        list_projects: [
          '📋 Дживс просматривает список проектов...',
          '🔍 Дживс изучает текущие проекты...',
          '📑 Дживс анализирует состояние проектов...',
          '📚 Дживс проверяет статусы проектов...',
          '📖 Дживс составляет отчет по проектам...',
        ],
        search: [
          '🔍 Дживс ищет по вашему запросу...',
          '📚 Дживс просматривает базу данных...',
          '🔎 Дживс анализирует похожие записи...',
          '📑 Дживс собирает результаты поиска...',
          '📖 Дживс формирует отчет по найденному...',
        ],
        delete_memory: [
          '🗑️ Дживс убирает устаревшие воспоминания...',
          '✂️ Дживс очищает ненужные записи из памяти...',
          '🧹 Дживс наводит порядок в воспоминаниях...',
          '📤 Дживс удаляет неактуальные сведения...',
          '🗄️ Дживс архивирует старые заметки...',
        ],
        update_memory: [
          '🔄 Дживс обновляет свои воспоминания...',
          '✏️ Дживс корректирует записи в памяти...',
          '📝 Дживс уточняет имеющиеся сведения...',
          '✍️ Дживс актуализирует информацию...',
          '📔 Дживс освежает важные детали...',
        ],
        get_message_history: [
          '🤔 Дживс вспоминает наш недавний разговор...',
          '💭 Дживс восстанавливает в памяти нашу беседу...',
          '🧠 Дживс собирается с мыслями...',
          '💫 Дживс погружается в воспоминания...',
          '🎭 Дживс воскрешает в памяти детали диалога...',
        ],
        thinking: [
          '🎩 Дживс задумчиво поправляет галстук...',
          '🧐 Дживс деликатно прочищает горло, обдумывая ответ...',
          '🤔 Дживс изящно приподнимает бровь, размышляя над вопросом...',
          '✨ Дживс с безупречной выдержкой обращается к своему опыту...',
          '👔 Дживс элегантно расправляет жилет, готовясь ответить...',
          '📚 Дживс погружается в свои энциклопедические познания...',
          '⚜️ Дживс с присущей ему обстоятельностью обдумывает ситуацию...',
        ],
        add_alarm: [
          '⏰ Дживс устанавливает новое напоминание...',
          '🕐 Дживс заводит будильник...',
          '📅 Дживс отмечает важную дату в календаре...',
          '⌚ Дживс программирует оповещение...',
          '🔔 Дживс настраивает уведомление...',
        ],
        update_alarm: [
          '⏰ Дживс корректирует время напоминания...',
          '🕐 Дживс перенастраивает будильник...',
          '📅 Дживс обновляет запись в календаре...',
          '⌚ Дживс меняет настройки оповещения...',
          '🔔 Дживс редактирует уведомление...',
        ],
        delete_alarm: [
          '⏰ Дживс отключает будильник...',
          '🗑️ Дживс убирает ненужное напоминание...',
          '✂️ Дживс вычеркивает напоминание из списка...',
          '📤 Дживс удаляет установленный будильник...',
          '🧹 Дживс наводит порядок в напоминаниях...',
        ],
        list_alarms: [
          '⏰ Дживс проверяет установленные будильники...',
          '📋 Дживс просматривает список напоминаний...',
          '🔍 Дживс изучает запланированные уведомления...',
          '📑 Дживс сверяется с расписанием напоминаний...',
          '📚 Дживс проверяет будущие напоминания...',
        ],
        ask_user: [
          '❓ Дживс почтительно ожидает ваших указаний...',
          '📝 Дживс замер в ожидании ваших инструкций...',
          '🎩 Дживс деликатно ждет вашего решения...',
          '✨ Дживс внимательно прислушивается к вашим словам...',
        ],
      },
      changeSummary: {
        task: {
          created: '- добавлена задача [{{title}}](/task/{{id}})',
          updated: '- изменена задача [{{title}}](/task/{{id}})',
          deleted: '- удалена задача «{{title}}»',
          completed: '- выполнена задача [{{title}}](/task/{{id}})',
        },
        project: {
          created: '- добавлен проект {{title}}',
          updated: '- изменён проект {{title}}',
          deleted: '- удалён проект {{title}}',
        },
        alarm: {
          created: '- добавлено напоминание «{{title}}»',
          updated: '- изменено напоминание «{{title}}»',
          deleted: '- удалено напоминание «{{title}}»',
        },
        memory: {
          created: '- запомнил: «{{title}}»',
          updated: '- обновил запись: «{{title}}»',
          deleted: '- удалил запись: «{{title}}»',
        },
      },
      jeeves: {
        messages: {
          applyAction: 'Хорошо, примени это',
          cancel: 'Отмена',
          error: 'Произошла ошибка!',
          cancelButton: '❌ Отмена',
          ok: '✅ ok',
          userNotFound: 'Пользователь не найден',
          taskNotFound: 'Задача не найдена',
          suggestAlternative: 'Предложи другой вариант',
          analyzeTaskPrompt: 'Пожалуйста, проанализируй задачу:',
          sessionCleared: 'Как пожелаете, сэр. Наш предыдущий разговор завершён. Чем могу помочь?',
          sessionClosed: 'Полагаю, предыдущий вопрос разрешён, сэр. К вашим услугам для нового обсуждения.',
          photoError:
            'К сожалению, сэр, мне не удалось обработать фотографию. Быть может, вы попробуете отправить её ещё раз?',
          errorTemplate: `<b>🎩 Прошу прощения, но я столкнулся с затруднением при обработке вашего сообщения.</b>

К моему глубочайшему сожалению, произошла техническая неполадка. Позвольте предоставить детали:
    
<blockquote expandable>{{error}}</blockquote>
    `,
        },
        buttons: {
          cancel: '❌ Отмена',
          suggestAlternative: '🤔 Предложи другой вариант',
          apply: '✅ Хорошо',
        },
      },
    },
  },
}
